export default __webpack_public_path__ + "assets/8f7afbe9cf8c8375ca5023777bf132ad.png";